/* eslint-disable @typescript-eslint/naming-convention */
export enum SearchCriteriaSortFieldEnum {
    published = 'PUBLISHED_DATE',
    indexed_date = 'INDEXED_DATE',
    audience_reach = 'AUDIENCE_REACH',
    relevancy = 'RELEVANCY',
    domainAuthority = 'DOMAIN_AUTHORITY',
    share = 'SHARE',
    like = 'LIKE',
    quote = 'QUOTE',
    reply = 'REPLY',
    view = 'VIEW',
    engagement_total = 'ENGAGEMENT_TOTAL',
    engagement_rate = 'ENGAGEMENT_RATE',
    function = 'FUNCTION',
    ave = 'AVE',
    custom = 'CUSTOM'
}
